import React, { useState, useEffect } from 'react';
import playStore from 'assets/images/icon/android.png';
import appStore from 'assets/images/icon/apple.png';

const Playlist = () => {
  const [platform, setPlatform] = useState('desktop');

  useEffect(() => {
    const userAgent = navigator.userAgent;
    const userAgentLower = userAgent.toLowerCase();
    
    if (userAgentLower.includes('android')) {
      setPlatform('android');
    } else if (userAgentLower.includes('iphone')) {
      setPlatform('ios');
    } else if (userAgentLower.includes('ipad')) {
      setPlatform('ios');
    } else if (userAgentLower.includes('mac os x')) {
      setPlatform('desktop');
    } else if (userAgentLower.includes('windows')) {
      setPlatform('desktop');
    } else if (userAgentLower.includes('linux')) {
      setPlatform('desktop');
    } else {
      setPlatform('desktop');
    }
  }, []);

  const getAppUrl = () => {
    if (platform === 'android') {
      return 'https://play.google.com/store/apps/details?id=com.inharmony.app';
    } else if (platform === 'ios') {
      return 'https://apps.apple.com/us/app/inharmony-music-meditations/id1532172047';
    }
    return 'https://apps.apple.com/us/app/inharmony-music-meditations/id1532172047';
  };

  const isAndroid = platform === 'android';

  return (
    <div className="redirect-container">
      <div className="redirect-content">
        <h1 className="redirect-title">You don't have the InHarmony app</h1>
        <p className="redirect-subtitle">Experience music meditations and mindfulness</p>
        <a 
          className="install-button" 
          href={getAppUrl()}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="button-icon">
            <img 
              src={isAndroid ? playStore : appStore} 
              alt={isAndroid ? 'Play Store' : 'App Store'} 
              width={20} 
              height={20} 
            />
          </span>
          {isAndroid ? 'Install from Play Store' : 'Install from App Store'}
        </a>
      </div>
    </div>
  );
};
export default Playlist;
